
<template>
     <div class="all-notifications" :class="{ 'notification-loading' : loading }">
         <nav class="panel column is-10 is-offset-1">
            <div class="panel-heading">
                <o-checkbox v-model="selectAll"></o-checkbox>
                <div class="container is-widescreen is-flex is-justify-content-space-between is-align-items-center">
                  <h1>All Notifications</h1>
                  <span class="is-flex">
                    <div style="padding: 10px" v-if="selectedNotifications.length > 0">
                      <button class="button is-warning" @click="readSelectedNotification">Mark as Read selected</button>
                    </div>
                    <div style="padding: 10px" v-if="selectedNotifications.length > 0">
                      <button class="button is-danger" @click="dismissSelectedNotification">Dismiss selected</button>
                    </div>
                     <div style="padding: 10px" v-if="selectedNotifications.length > 0">
                      <button class="button is-warning" @click="readAll">Mark all as Read</button>
                    </div>
                    <div style="padding: 10px" v-if="selectedNotifications.length > 0">
                      <button class="button is-danger" @click="dismissAll">Dismiss all</button>
                    </div>
                  </span>
                  </div>
            </div>
            <p class="panel-tabs">
                <a :class="{ 'is-active': filters.queryType === 0 }" @click="filters.queryType = 0">Unread</a>
                <a :class="{ 'is-active': filters.queryType === 1 }" @click="filters.queryType = 1">All</a>
                <a :class="{ 'is-active': filters.queryType === 2 }" @click="filters.queryType = 2">Read</a>
            </p>
            <div
            v-for="notification in paginatedData"
                :key="notification.id"
                class="panel-block"
            >
                <o-checkbox v-model="notification.selected"></o-checkbox>
                <div class="notification-content" @click="notificationAction(notification)">
                    <o-icon size="is-small" pack="fa" icon="envelope"></o-icon>
                    <span class="link-description" :class="{ 'has-text-weight-bold': !notification.read_at }" v-if="notification.data.message">{{ notification.data.message }}</span>
                    <span class="datetime is-pulled-right">{{ $filters.datetime(notification.created_at) }}</span>
                </div>

              <div style="padding: 10px">
                <button class="button is-warning" @click="readNotification(notification)">Mark as Read</button>
              </div>

              <div style="padding: 10px">
                <button class="button is-danger" @click="dismissNotification(notification)">Dismiss</button>
              </div>

            </div>
            <o-pagination
                v-if="total > table.perPage"
                :total="total"
                :per-page="table.perPage"
                v-model:current="currentPage"
                range-before="5"
                range-after="5"
                class="is-pulled-right"
            >
            </o-pagination>
         </nav>
     </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Table from './../mixins/Table'

    export default {
        mixins: [Table],

        data () {
            return {
               
               selectAll: false,
               filters: {
                   queryType: 0
               }
            }
        },
        watch: {
            selectAll(value) {
                this.paginatedData.forEach(n => n.selected = value)
            },
            currentPage() {
                this.fetchPaginatedData(false)
            },
            'filters.queryType'() {
                this.fetchPaginatedData(true)
            }
        },
        mounted() {
            this.fetchPaginatedData(false)
        },
        computed: {
            ...mapGetters( { itemsByIds: 'notificationsByIds'} ),
            selectedNotifications() {
                return _.filter(this.paginatedData, n => n.selected)
            }
        },

        methods: {
            ...mapActions(['readNotification', 'dismissNotification', 'readAllNotifications', 'dismissAllNotifications']),
            ...mapActions({ fetchData : 'fetchNotifications' }),
            readSelectedNotification() {
                _.each(this.selectedNotifications, notification => {
                    if (!notification.read_at) {
                        notification.read_at = -1
                        notification.selected = false
                        this.readNotification(notification)
                        this.fetchPaginatedData(true)
                        window.location.reload()
                    }
                })
            },
            dismissSelectedNotification() {
                _.each(this.selectedNotifications, notification => {
                    this.dismissNotification(notification)
                  window.location.reload()
                })
            },
            readAll () {
                this.readAllNotifications().then((p) => {
                  window.location.reload()
                  this.fetchPaginatedData(false)
                })
            },
            dismissAll () {
                this.confirmMessage('Dismiss All', 'Do you want to Dismiss all notifications? this can not be undone', 'Dismiss').then(p => {
                    this.dismissAllNotifications().then((p) => {
                      window.location.reload()
                      this.fetchPaginatedData(false)
                    })
                })
            },
            notificationAction(notification) {
                this.readNotification(notification)
                if(notification.data.action) {
                    switch (notification.data.action) {
                        case 'change_order_remind_by':
                        case 'proposal_remind_by':
                            this.readNotification(notification)
                            this.navigate(notification.data.url)
                            break
                    }
                } else {
                    this.navigate(notification.data.url)
                }              
            },
            navigate(url) {
                this.$router.push({ path: url })
            },
        }
    }
</script>

<style>
    
.all-notifications .panel-block {
    display: flex;
    padding: 10px;
    background-color: #fff;
    line-height: 1.5;
}

.all-notifications .panel-block:hover {
    background-color: #e0e0e0;
    cursor: pointer;
}

.all-notifications .panel-block .notification-content {
    width: 100%;
    display: block;
}

.all-notifications .panel .panel-heading {
    justify-content: left;
    line-height: 1.5;
}

.all-notifications .dropdown.table-actions {
    margin: 0px 5px;
}

.all-notifications .pagination {
    margin-top: 10px;
}

.all-notifications.notification-loading {
    opacity: 0.5;
}

</style>
